/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ClassUtils } from "abweb/utils/ClassUtils";

//this utility class is for the common case where you can input either a T or a (() => T) to a method.
//optionally you can specify your supplier to
export let Supplier;
(function (_Supplier) {
  function resolve(t) {
    if (ClassUtils.isInstanceOf(t, Function)) {
      return Supplier.resolve(t());
    }
    return t;
  }
  _Supplier.resolve = resolve;
  function resolveError(e) {
    const errorStringOrObject = Supplier.resolve(e);
    return typeof errorStringOrObject === "string" ? new Error(errorStringOrObject) : errorStringOrObject;
  }
  _Supplier.resolveError = resolveError;
})(Supplier || (Supplier = {}));
//# sourceMappingURL=Supplier.js.map
